function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3.114C1 1.946 1.896 1 3.002 1h8.996C13.104 1 14 1.946 14 3.114v5.383l-.982-.929V3.114c0-.595-.457-1.077-1.02-1.077H3.002c-.563 0-1.02.482-1.02 1.077v8.773c0 .594.457 1.076 1.02 1.076h5.5V14h-5.5C1.896 14 1 13.054 1 11.886V3.114z",
  fill: "#2D2D2D"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 2.086c0-.565.458-1.023 1.024-1.023h.952C8.542 1.063 9 1.52 9 2.086v.828c0 .565-.458 1.023-1.024 1.023h-.952A1.024 1.024 0 016 2.914v-.828zm1.024-.217a.217.217 0 00-.217.217v.828c0 .12.097.217.217.217h.952c.12 0 .217-.097.217-.217v-.828a.217.217 0 00-.217-.217h-.952zM11 7.994c-1.715 0-3.056 1.373-3.056 3.006 0 1.633 1.341 3.006 3.056 3.006s3.056-1.373 3.056-3.006c0-1.633-1.341-3.006-3.056-3.006zM7 11a4 4 0 014-4 4 4 0 110 8 4 4 0 01-4-4z",
  fill: "#2D2D2D"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.219 9.809a.495.495 0 010 .729l-2.43 2.29-1.918-1.809a.495.495 0 010-.729.57.57 0 01.773 0l1.145 1.08 1.657-1.561a.57.57 0 01.773 0z",
  fill: "#2D2D2D"
});
function SvgPaquetelisto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}
export default __webpack_public_path__ + "/img/Paquete listo.svg";
export { SvgPaquetelisto as ReactComponent };